import { render, staticRenderFns } from "./CheckoutDeliveryMethod.vue?vue&type=template&id=802dba1c&scoped=true"
import script from "./CheckoutDeliveryMethod.vue?vue&type=script&lang=js"
export * from "./CheckoutDeliveryMethod.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDeliveryMethod.vue?vue&type=style&index=0&id=802dba1c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802dba1c",
  null
  
)

export default component.exports